import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-citizen-home-footer',
  templateUrl: './citizen-home-footer.component.html',
  styleUrl: './citizen-home-footer.component.css',
})
export class CitizenHomeFooterComponent implements OnInit, AfterViewInit {
  mailprofessionel = 'contact@efb.bj ';
  currentYear: number = new Date().getFullYear();

  constructor(
    private _router: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('fr');

    this._router.params.subscribe((params) => {
      const lang = params['lang'];
      this.translate.use(lang.match(/en|fr/) ? lang : 'en');
    });
  }

  ngAfterViewInit(): void {}

  ngOnInit(): void {}
}
